import { getLocalizedValue } from "@grandvisionhq/utils";
const getProductTag = (variant, locale) => {
  const zeroDiscount = getZeroDiscountValue(variant, locale);
  const tags = variant.tags;
  if (zeroDiscount) {
    return {
      key: null,
      value: zeroDiscount
    };
  }
  if (tags && tags[0]) {
    const value = typeof tags[0].value !== "string" ? getLocalizedValue(tags[0].value, locale) : tags[0].value;
    return {
      key: tags[0].key,
      value
    };
  }
  return void 0;
};
const getZeroDiscountValue = (variant, locale) => {
  if (!Array.isArray(variant.prices) || !variant.prices[0]) {
    return void 0;
  }
  const { discounted } = variant.prices[0];
  if (!discounted || !discounted.discount?.obj) return void 0;
  const { value, description } = discounted.discount?.obj;
  let discountLabel = void 0;
  if (value.type === "absolute") {
    discountLabel = description && (value.money && value.money[0]?.centAmount) === 0 ? getLocalizedValue(description, locale) : void 0;
  } else if (value.type === "relative") {
    discountLabel = description && value.permyriad === 0 ? getLocalizedValue(description, locale) : void 0;
  }
  return discountLabel;
};
export {
  getProductTag
};
//# sourceMappingURL=get-product-tag.js.map
